export * from '@cipafacil/services/confirmation/public-api';
